module.exports = __webpack_public_path__ + "static/media/S7.9add4cbb.webp";